export default "__VITE_ASSET__nHP_XRXf__"